(function() {

	angular
		.module('ngmvac')
		.filter('packageFilter', Package)
		.filter('packageFilter2', Pack);

	function Pack() {
		return function(hotels, cotizador) {
			var paquete = [];
			angular.forEach(hotels, function(hotel) {

				for (var i = 0; i < hotel.rooms.length; i++) {
					for( var _i = 0; _i < hotel.rooms[i].rates.length; _i++ ) {
						var rateActual = hotel.rooms[i].rates[_i];
						rateActual.roomName = hotel.rooms[i].name;
						var cotizadorCopia = cotizador.occupancies.slice();

						for( var __i = 0; __i < cotizadorCopia.length; __i++ ) {
							if( rateActual.adults == cotizadorCopia[__i].adults
							 	&& rateActual.children == cotizadorCopia[__i].children
								&& rateActual.rooms == cotizadorCopia[__i].rooms) {
									var el = cotizadorCopia.splice(__i, 1);
								}
						}
						console.log(cotizadorCopia);

						for( var _i_ = 0; _i_ < cotizadorCopia.length; _i_++ ) {
							for(var i_ = 0; i_ < hotel.rooms.length; i_++) {

								if( i_ >= i ) {
									console.log(hotel.rooms[i_]);
									var paqueteTemp = [];
									paqueteTemp.push(rateActual);
									for( var i__ = 0; i__ < hotel.rooms[i_].rates.length; i__++ ) {
										if( _i <= i__ ) {
											console.log(_i);
											// console.log('comparando');
											// console.log(cotizadorCopia[_i_]);
											// console.log(hotel.rooms[i_].rates[i__]);
											if( cotizadorCopia[_i_].adults == hotel.rooms[i_].rates[i__].adults
											 	&& cotizadorCopia[_i_].children == hotel.rooms[i_].rates[i__].children
												&& cotizadorCopia[_i_].rooms == hotel.rooms[i_].rates[i__].rooms) {
													// console.log('Aprobo');

													console.log(hotel.rooms[i_].rates[i__]);
													var r = hotel.rooms[i_].rates[i__];
													r.roomName = hotel.rooms[i_].name;
													paqueteTemp.push(r);
												}
										}
									}
									paquete.push(paqueteTemp);
								}

							}
						}
					}
				}
			});

			return paquete;

		}
	}

	function Package() {
		return function(hotels, cotizador) {

			var totalAdults = 0;
			var totalRooms = 0;
			var totalChildren = 0;

			angular.forEach(cotizador.occupancies, function (_value, _index) {
				totalAdults += parseFloat(_value.adults) * parseFloat(_value.rooms);
				totalRooms += parseFloat(_value.rooms);
				totalChildren += parseFloat(_value.children) * parseFloat(_value.rooms);
			});

			// console.log(totalAdults, totalChildren, totalRooms);

			var isComplete = function(rateParam) {
				return ((rateParam.adults * rateParam.rooms) == totalAdults) &&
					   ((rateParam.children * rateParam.rooms) == totalChildren) &&
					   (rateParam.rooms == totalRooms);
			}

			var isTheSameArray = function(arr1, arr2) {
				var clArr1 = arr1.slice();
				if( arr1.length == arr2.length ) {
					while(clArr1.length > 0) {
						var val = clArr1.splice(0, 1);
						var finded = false;
						for(var i = 0; i < arr2.length; i++) {
							if( val == arr2[i] ) {
								finded = true;
								break;
							}
						}
						if(!finded) {
							return false;
						}
					}
				} else {
					return false;
				}
				return true;
			}

			angular.forEach( hotels, function(hotel) {
				var package = [];
				var packageGrouped = [];
				angular.forEach(hotel.rooms, function(room, indexRoom) {

					var occupancies = cotizador.occupancies.slice();
					var packageAux = [];

					angular.forEach(occupancies, function(occupancy, indexOccupancy) {

						var indOccupancy = 0;

						var children = occupancy.children;
						var adults = occupancy.adults;
						var rooms = occupancy.rooms;

						angular.forEach(room.rates, function(rate, indexRate) {

							var _validInsertion_ = (rate.adults == adults && rate.children == children && rate.rooms == rooms);
							if( _validInsertion_ ) {

								var boardExist = false;
								var indexSearch = 0;
								angular.forEach(packageAux, function(package, packageIndex) {
									if( rate.boardCode == package.boardCode ) {
										boardExist = true;
										indexSearch = packageIndex;
									}
								});

								if( boardExist ) {
									// Comparacion para insertar rate en paquete
									var validInsertion = true;

									for( var _i = 0; _i < packageAux[indexSearch].rooms.length; _i++ ) {
										var childrenAgesArray1 = rate.childrenAges.split(',');
										var childrenAgesArray2 = packageAux[indexSearch].rooms[_i].childrenAges.split(',');

										var _validInsertion =   (rate.adults != packageAux[indexSearch].rooms[_i].adults ||
																rate.children != packageAux[indexSearch].rooms[_i].children ||
																!isTheSameArray(childrenAgesArray1, childrenAgesArray2)) &&
																	rate.rateClass == packageAux[indexSearch].rooms[_i].rateClass;

										if( validInsertion !== _validInsertion ) {
											validInsertion = _validInsertion;
											break;
										}
									}

									if( validInsertion && _validInsertion_ ) {
										rate.roomName = room.name;
										rate.roomCode = room.code;
										packageAux[indexSearch].rooms.push(rate);

										var adultsAmount = 0;
										var childrensAmount = 0;
										var roomsAmount = 0;

										angular.forEach( packageAux[indexSearch].rooms, function(_room, _indexRoom) {
											adultsAmount += _room.adults * _room.rooms;
											childrensAmount += _room.children * _room.rooms;
											roomsAmount += _room.rooms;
										});

										packageAux[indexSearch].complete = (adultsAmount == totalAdults && childrensAmount == totalChildren && roomsAmount == totalRooms);
									}
									//Fin comparacion
								} else {
									rate.roomName = room.name;
									rate.roomCode = room.code;
									packageAux.push({
										rooms: [rate],
										boardCode: rate.boardCode,
										boardName: rate.boardName,
										complete: isComplete(rate)
									});
								}
							}

						});
					});

					angular.forEach(packageAux, function(pack, indexPackage) {

						var sum = 0;
						var sumD = 0;
						var nHabitaciones = 0;
						angular.forEach(pack.rooms, function(room, indexRoom) {
							sum += room.tarifaPublica;
							sumD += room.totalWithoutDiscount || room.tarifaPublica;
							nHabitaciones += room.rooms;
						});
						pack.price = sum;
						pack.priceWithoutDiscount = sumD;
						pack.nHabitaciones = nHabitaciones;

						package.push(pack);
					});
				});

				angular.forEach(package, function(_package, indexPackage) {
					if( packageGrouped.length > 0 ) {
						var insertedNew = true;

						angular.forEach(packageGrouped, function(group, indexGroup) {
							if( group[0].boardCode == _package.boardCode ) {
								group.push(_package);
								insertedNew = false;
							}
						});

						if( insertedNew ) {
							packageGrouped.push([_package]);
						}
					} else {
						packageGrouped.push([_package]);
					}
				});

				angular.forEach(packageGrouped, function(group, groupIndex) {
					angular.forEach(group, function(_package, indexPackage) {
						if( !_package.complete ) {
							/*console.log('No esta completo el paquete: ');
							console.log(_package);*/
							var _occupancies = cotizador.occupancies.slice();

							angular.forEach(_occupancies, function(_occupancy, _indexOccupancy) {
								var _occupancyExists = false;

								angular.forEach(_package.rooms, function(_room, indexRoom) {

									if( _room.childrenAges.length > 0 ) {
										var childrenAgesArray1 = _room.childrenAges.split(',');
									} else {
										var childrenAgesArray1 = [];
									}

									var childrenAgesArray2 = [];
									angular.forEach(_occupancy.paxes, function(_pax) {
										childrenAgesArray2.push(_pax.age);
									});
									/*console.log(_package);
									console.log(childrenAgesArray1);
									console.log(childrenAgesArray2);
									console.log(isTheSameArray(childrenAgesArray1, childrenAgesArray2))*/
									if( _room.adults == _occupancy.adults &&
										_room.children == _occupancy.children &&
										_room.rooms == _occupancy.rooms &&
										isTheSameArray(childrenAgesArray1, childrenAgesArray2)) {
										_occupancyExists = true;
									}
								});

								if( !_occupancyExists ) {
									var roomFound = false;

									for( var _i = 0; _i < group.length; _i++ ) {
										if( indexPackage != _i ) {
											angular.forEach(group[_i].rooms, function(__room, __indexRoom) {

												if( __room.childrenAges.length > 0 ) {
													var childrenAgesArray1 = __room.childrenAges.split(',');
												} else {
													var childrenAgesArray1 = [];
												}
												var childrenAgesArray2 = [];
												angular.forEach(_occupancy.paxes, function(_pax) {
													childrenAgesArray2.push(_pax.age);
												});

												if(__room.adults == _occupancy.adults &&
													__room.children == _occupancy.children &&
													__room.rooms == _occupancy.rooms &&
													isTheSameArray(childrenAgesArray1, childrenAgesArray2) &&
													!roomFound ) {

													_package.rooms.push(__room);
													roomFound = true;
													var _adultsAmount = 0;
													var _childrenAmount = 0;
													var _roomsAmount = 0;
													_package.price += __room.tarifaPublica;
													_package.priceWithoutDiscount += __room.totalWithoutDiscount || __room.tarifaPublica;
													_package.nHabitaciones += __room.rooms;

													angular.forEach(_package.rooms, function(_room_, _indexRoom_) {
														_adultsAmount += _room_.adults * _room_.rooms;
														_childrenAmount += _room_.children * _room_.rooms;
														_roomsAmount += _room_.rooms;
													});

													_package.complete = (_adultsAmount == totalAdults &&
																						_childrenAmount == totalChildren &&
																						_roomsAmount == totalRooms);

												}
											});
											if(_package.complete) {
												break;
											}
										}
									}
								}
							});
						}
					});
				});

				// Asignacion de los paquetes
				hotel.packageGrouped = packageGrouped;
			});

			return hotels;

		}
	}

})();
